/**
 * Sector codes for Dutch industries (CAO sectoren)
 * Used for manual sector code selection when KvK lookup fails
 */

export interface SectorCode {
	value: string;
	label: string;
	subCategorie: boolean;
}

export const sectorCodes: SectorCode[] = [
	{ value: '1', label: '01. Agrarisch bedrijf', subCategorie: false },
	{ value: '2', label: '02. Tabakverwerkende industrie', subCategorie: false },
	{ value: '3', label: '03. Bouwbedrijf', subCategorie: false },
	{ value: '4', label: '04. Baggerbedrijf', subCategorie: false },
	{
		value: '5',
		label: '05. Houten emballage-industrie, houtwaren- en borstelindustrie',
		subCategorie: false
	},
	{ value: '6', label: '06. Timmerindustrie', subCategorie: false },
	{ value: '7', label: '07. Meubel- en orgelbouwindustrie', subCategorie: false },
	{
		value: '8',
		label: '08. Groothandel hout, zagerijen, schaverijen en houtbereidingsind.',
		subCategorie: false
	},
	{ value: '9', label: '09. Grafische industrie', subCategorie: false },
	{ value: '10', label: '10. Metaalindustrie', subCategorie: false },
	{ value: '11', label: '11. Elektrotechnische industrie', subCategorie: false },
	{ value: '12', label: '12. Metaal- en technische bedrijfstakken', subCategorie: false },
	{ value: '13', label: '13. Bakkerijen', subCategorie: false },
	{ value: '14', label: '14. Suikerverwerkende industrie', subCategorie: false },
	{ value: '15', label: '15. Slagersbedrijven', subCategorie: false },
	{ value: '16', label: '16. Slagers overig', subCategorie: false },
	{ value: '17', label: '17. Detailhandel en ambachten', subCategorie: false },
	{ value: '17.1', label: '  17.1. Detailhandel', subCategorie: true },
	{ value: '17.2', label: '  17.2. Kappers', subCategorie: true },
	{ value: '17.3', label: '  17.3. Ambachten', subCategorie: true },
	{ value: '17.4', label: '  17.4. Meubilering', subCategorie: true },
	{ value: '17.5', label: '  17.5. Huispersoneel', subCategorie: true },
	{ value: '18', label: '18. Reiniging', subCategorie: false },
	{ value: '19', label: '19. Grootwinkelbedrijf', subCategorie: false },
	{ value: '20', label: '20. Havenbedrijven', subCategorie: false },
	{ value: '21', label: '21. Havenclassificeerders', subCategorie: false },
	{ value: '22', label: '22. Binnenscheepvaart', subCategorie: false },
	{ value: '23', label: '23. Visserij', subCategorie: false },
	{ value: '24', label: '24. Koopvaardij', subCategorie: false },
	{ value: '25', label: '25. Vervoer KLM', subCategorie: false },
	{ value: '26', label: '26. Vervoer NS', subCategorie: false },
	{ value: '27', label: '27. Vervoer posterijen', subCategorie: false },
	{ value: '28', label: '28. Taxi- en ambulancevervoer', subCategorie: false },
	{ value: '29', label: '29. Openbaar Vervoer', subCategorie: false },
	{ value: '30', label: '30. Besloten busvervoer', subCategorie: false },
	{
		value: '31',
		label: '31. Overig personenvervoer te land en in de lucht',
		subCategorie: false
	},
	{
		value: '32',
		label: '32. Overig goederenvervoer te land en in de lucht',
		subCategorie: false
	},
	{ value: '33', label: '33. Horeca algemeen', subCategorie: false },
	{ value: '34', label: '34. Horeca catering', subCategorie: false },
	{
		value: '35',
		label: '35. Gezondheid, geestelijke en maatschappelijke belangen',
		subCategorie: false
	},
	{ value: '35.1', label: '  35.1. Verpleging en verzorging', subCategorie: true },
	{ value: '35.2', label: '  35.2. Overig', subCategorie: true },
	{ value: '36', label: '36. Overheidsdiensten', subCategorie: false },
	{ value: '38', label: '38. Banken', subCategorie: false },
	{ value: '39', label: '39. Verzekeringswezen en ziekenfondsen', subCategorie: false },
	{ value: '40', label: '40. Uitgeverij', subCategorie: false },
	{ value: '41', label: '41. Groothandel I', subCategorie: false },
	{ value: '42', label: '42. Groothandel II', subCategorie: false },
	{ value: '43', label: '43. Zakelijke Dienstverlening I', subCategorie: false },
	{ value: '44', label: '44. Zakelijke Dienstverlening II', subCategorie: false },
	{ value: '45', label: '45. Zakelijke Dienstverlening III', subCategorie: false },
	{ value: '46', label: '46. Zuivelindustrie', subCategorie: false },
	{ value: '47', label: '47. Textielindustrie', subCategorie: false },
	{
		value: '48',
		label: '48. Steen-, cement-, glas- en keramische industrie',
		subCategorie: false
	},
	{ value: '49', label: '49. Chemische industrie', subCategorie: false },
	{ value: '50', label: '50. Voedingsindustrie', subCategorie: false },
	{ value: '51', label: '51. Algemene industrie', subCategorie: false },
	{ value: '52', label: '52. Uitzendbedrijven', subCategorie: false },
	{ value: '52.1', label: '  52.1. Uitzendbedrijven administratief', subCategorie: true },
	{ value: '52.2', label: '  52.2. Uitzendbedrijven technisch', subCategorie: true },
	{ value: '52.3', label: '  52.3. Detacheringsbedrijf', subCategorie: true },
	{ value: '52.4', label: '  52.4. Intermediaire bedrijven', subCategorie: true },
	{ value: '52.5', label: '  52.5. Payroll bedrijven', subCategorie: true },
	{ value: '53', label: '53. Bewakingsondernemingen', subCategorie: false },
	{ value: '54', label: '54. Culturele instellingen', subCategorie: false },
	{ value: '55', label: '55. Overige takken van bedrijf en beroep', subCategorie: false },
	{ value: '56', label: '56. Schildersbedrijf', subCategorie: false },
	{ value: '57', label: '57. Stukadoorsbedrijf', subCategorie: false },
	{ value: '58', label: '58. Dakdekkerbedrijf', subCategorie: false },
	{ value: '59', label: '59. Mortelbedrijf', subCategorie: false },
	{ value: '60', label: '60. Steenhouwersbedrijf', subCategorie: false },
	{ value: '61', label: '61. Overheid, onderwijs en wetenschappen', subCategorie: false },
	{ value: '62', label: '62. Overheid, rijk, politie en rechterlijke macht', subCategorie: false },
	{ value: '63', label: '63. Overheid, defensie', subCategorie: false },
	{
		value: '64',
		label: '64. Overheid, provincies, gemeenten en waterschappen',
		subCategorie: false
	},
	{ value: '65', label: '65. Overheid, openbare nutsbedrijven', subCategorie: false },
	{ value: '66', label: '66. Overheid, overige instellingen', subCategorie: false },
	{ value: '67', label: '67. Werk en (re)Integratie', subCategorie: false },
	{ value: '68', label: '68. Railbouw', subCategorie: false },
	{ value: '69', label: '69. Telecommunicatie', subCategorie: false }
];

/**
 * Get sector code label by value
 * @param value - The sector code value
 * @returns The full label or null if not found
 */
export const getSectorCodeLabel = (value: string): string | null => {
	const sector = sectorCodes.find((s) => s.value === value);
	return sector ? sector.label : null;
};

/**
 * Search sector codes by keyword (case-insensitive)
 * @param keyword - The search term
 * @returns Array of matching sector codes
 */
export const searchSectorCodes = (keyword: string): SectorCode[] => {
	if (!keyword.trim()) {
		return sectorCodes;
	}
	const lowerKeyword = keyword.toLowerCase();
	return sectorCodes.filter(
		(sector) =>
			sector.value.includes(lowerKeyword) || sector.label.toLowerCase().includes(lowerKeyword)
	);
};
